// Demo hardcoded para el bar "duvel-moortgat".
// En esta versión todo se deriva del slug; no hay campo en el modelo
// ni endpoint admin. La primera sección del menú de ese bar queda
// fijada en posición 0 y se marca con el highlight "Gold thread".
//
// Para generalizar a un sistema multi-partner basta con sustituir
// estas comprobaciones por la lectura de `bar.partner` cuando se
// introduzca ese campo en el modelo. El resto del código que usa
// estos helpers no tendría que cambiar.

export const PARTNER_DEMO_SLUG = 'duvel-moortgat'

export const isPartnerDemoBar = (bar: { slug?: string | null } | null | undefined): boolean => {
  return !!bar && bar.slug === PARTNER_DEMO_SLUG
}

export const isPartnerDemoSection = (
  bar: { slug?: string | null } | null | undefined,
  sectionIndex: number
): boolean => {
  return isPartnerDemoBar(bar) && sectionIndex === 0
}

// Texto del badge "Recomendadas" en los 6 idiomas del menú.
export const partnerBadgeText: Record<string, string> = {
  es: 'Recomendadas',
  en: 'Recommended',
  fr: 'Recommandées',
  ca: 'Recomanades',
  de: 'Empfohlen',
  eu: 'Gomendatuak'
}
